import * as _4 from 'lodash4';
import { ITimeOccurrenceDatatype, IRawTimeOccurrenceDatatype, ITimeChangeParams, ITimeRange } from 'ui-ng-calendar';
import { ICommand } from 'core-ts-types';
import { TimeOccurrenceServant } from 'ui-ng-calendar';
import { PhxCalendarConfiguration } from 'ui-ng-calendar';
import { IDayOfTheWeekEnum } from 'utility-js-time';
import { IChangedBusyTimeDatasource } from 'ui-ng-calendar';
import { IChangedBusyTime } from 'ui-ng-calendar';
import { BusyTimeErrorMessage } from 'ui-ng-calendar';

interface IEnum {
  key: string;
  value: any;
  ordinal: number;
}

interface ITimeObject {
  defaultTime: ITimeOccurrenceDatatype;
  potentialTime: IRawTimeOccurrenceDatatype;
}

export interface IErrors {
  found: Array<string>;
}

export class AddBusyTimeController {
  enums: any;
  hourStep: string;
  hourBegin: string;
  outerCb: Function;
  newTime: ITimeObject;
  inputInnerValidation: boolean;
  isSavingNewTime: boolean;
  showSaveButton: boolean;
  isValidTime: boolean;
  uniqueId: string;
  errors: IErrors;
  timeRange: ITimeRange;

  constructor(
    private DayOfTheWeekEnum: IDayOfTheWeekEnum,
    private ngTimeOccurrenceServant: TimeOccurrenceServant,
    private addNewPotentialTimeCommand: ICommand,
    private createDefaultTimeCommand: ICommand,
    private ngChangedBusyTimeDatasource: IChangedBusyTimeDatasource,
    private ngPhxCalendarConfiguration: PhxCalendarConfiguration,
    private startTimeDatasourceTransactionCommand: ICommand,
    private endTimeDatasourceTransactionCommand: ICommand,
    private deleteChangedBusyTimeCommand: ICommand,
    private saveChangedBusyTimeCommand: ICommand,
    public timeLockValidatorFactory: Function
  ) {
    this.newTime = {
      defaultTime: {} as ITimeOccurrenceDatatype,
      potentialTime: {
        day_of_week: 2,
        from_tm: null,
        to_tm: null
      }
    };

    this.inputInnerValidation = false;
    this.isSavingNewTime = false;
    this.isValidTime = true;

    this.errors = {
      found: []
    };

    const defaultRangeLimits: ITimeRange = {
      hourBegin: 6,
      hourEnd: 23
    };

    this.timeRange = {
      hourBegin: parseInt(ngPhxCalendarConfiguration.hourBegin, 10) || defaultRangeLimits.hourBegin,
      hourEnd: parseInt(ngPhxCalendarConfiguration.hourEnd, 10) || defaultRangeLimits.hourEnd
    };

    this.uniqueId = _4.uniqueId();
  }

  showAddNewTime() {
    const isSavingNewTime = this.isSavingNewTime;
    const noNewTime = _4.isEmpty(this.ngTimeOccurrenceServant.getNewTime(this.ngChangedBusyTimeDatasource));
    const updatingExistingTime = !_4.isEmpty(
      this.ngTimeOccurrenceServant.getUpdatedTimes(this.ngChangedBusyTimeDatasource)
    );
    return !isSavingNewTime && noNewTime && !updatingExistingTime;
  }

  onValueChange(event: any) {
    this.onTimeChanged({
      timeParams: {
        originalTime: undefined,
        timeProperty: event.target.getAttribute('time-property'),
        updatedTimeString: event.detail.value
      }
    });
  }

  $onDestroy() {
    this.onCancel();
  }

  onTimeChanged(timeChangeParams: ITimeChangeParams) {
    if (_4.isUndefined(timeChangeParams) && _4.isEmpty(timeChangeParams)) {
      return;
    }
    const militaryTime = moment(timeChangeParams.timeParams.updatedTimeString, 'hh:mm a').format('HH:mm');
    this.newTime.potentialTime[timeChangeParams.timeParams.timeProperty] = militaryTime;

    timeChangeParams.timeParams.timeProperty === 'from_tm'
      ? this.updateNewTime(this.newTime.defaultTime.trackingId, { from_tm: militaryTime })
      : this.updateNewTime(this.newTime.defaultTime.trackingId, { to_tm: militaryTime });
  }

  onDayChangedEvent(event: any) {
    const dayObj = this.DayOfTheWeekEnum.get(event.target.value.substring(2, 0));
    if (dayObj) {
      this.onDayChanged(dayObj);
    }
  }
  onDayChanged(DayObj: IEnum) {
    this.newTime.potentialTime['day_of_week'] = DayObj.ordinal;
    this.updateNewTime(this.newTime.defaultTime.trackingId, { day_of_week: DayObj.ordinal });
  }

  updateNewTime(id: string, timeObj: any) {
    let record = _4.find(this.ngChangedBusyTimeDatasource.read(), { tracking_id: id });
    if (record) {
      _4.merge(record, timeObj);
    }
  }

  onAdd() {
    this.createDefaultTimeCommand().then((newEmptyTime: ITimeOccurrenceDatatype) => {
      this.saveChangedBusyTimeCommand({
        tracking_id: newEmptyTime.trackingId,
        day_of_week: newEmptyTime.day,
        from_tm: newEmptyTime.from,
        to_tm: newEmptyTime.to,
        is_new_time: true
      });
      this.newTime.defaultTime = newEmptyTime;
      this.isSavingNewTime = true;
    });
  }

  onSave() {
    const newTime = this.ngTimeOccurrenceServant.getNewTime(this.ngChangedBusyTimeDatasource);
    if (!_4.isEmpty(newTime)) {
      this.validatePotentialTime(newTime);
    }

    if (!_4.isEmpty(newTime) && this.isValidTime) {
      this.startTimeDatasourceTransactionCommand();
      this.addNewPotentialTimeCommand(newTime).then((addNewResult: any) => {
        if (_4.isUndefined(addNewResult)) {
          this.displaySpecificError(BusyTimeErrorMessage['isTimeOverlap'].message);
        } else {
          this.deleteChangedBusyTimeCommand(newTime.tracking_id);
          this.isSavingNewTime = false;
          this.execCb();
        }
        this.endTimeDatasourceTransactionCommand();
      });
    }
  }

  validatePotentialTime(newTime: IChangedBusyTime) {
    this.errors.found = this.ngTimeOccurrenceServant.validatePotentialTime(newTime, this.errors, this.timeRange);
    this.isValidTime = _4.isEmpty(this.errors.found);
  }

  displaySpecificError(errorMsg: string): void {
    this.errors.found.push(errorMsg);
    this.isValidTime = false;
  }

  onCancel() {
    _4.remove(this.errors.found, undefined);
    this.deleteChangedBusyTimeCommand(this.newTime.defaultTime.trackingId);
    this.isSavingNewTime = false;
    this.execCb();
  }

  execCb() {
    return this.outerCb();
  }
}

angular
  .module('capability-ng-scheduler')
  .controller('addBusyTimeController', AddBusyTimeController)
  .component('addBusyTime', {
    bindings: {
      enums: '<',
      hourStep: '@',
      hourBegin: '@',
      outerCb: '&'
    },
    templateUrl: 'capability-ng-scheduler/src/components/add_busy_time/add_busy_time.html',
    controller: 'addBusyTimeController'
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/add_busy_time/add_busy_time.ts